// travel-messages translations (English catalog).
window.PlummeI18n.register('en', {
  'trv.privateRefundSuffix': 'is included in the next payroll payment without increasing taxable pay, holiday pay, employer\'s NI or OTP.',
  'trv.rejectReasonRequired': 'Enter a short reason for the rejection.',
  'trv.showApproved': 'Show approved',
  'trv.tripCounts': '{mileage} trips · {stays} overnight stays · {expenses} expenses',
  'trv.expenseSaved': 'Expense saved.',
  'trv.expenseSaveFailed': 'Could not save the expense.',
  'trv.voucherFetchFailed': 'Could not fetch the voucher.',
  'trv.voucherNoViewLink': 'No view link was found for the voucher.',
  'trv.viewVoucher': 'View voucher',
  'trv.travelSaveFailed': 'Could not save the trip.',
  'trv.statusUpdateFailed': 'Could not update the trip status.',
  'trv.deleteConfirm': 'Delete travel claim "{purpose}"?',
  'trv.travelDeleted': 'Trip deleted.',
  'trv.travelDeleteFailed': 'Could not delete the trip.',
  'trv.travelCopied': 'Trip copied to a new draft.',
  'trv.travelCopyFailed': 'Could not copy the trip.',
  'trv.viewDetails': 'View details',
  'trv.editLine': 'Edit the line',
  'trv.editedAfterSubmit': 'Changed after submission',
  'trv.tollAmount': 'toll {amount}',
  'trv.deleteTrip': 'Delete the trip',
  'trv.deleteStay': 'Delete the overnight stay',
  'trv.attachmentMark': '● Attachment',
  'trv.deleteExpense': 'Delete the expense',
  'trv.history': 'History',
  'trv.historyHelp': 'Who has changed the travel claim, and when.',
  'trv.companyPaidDirect': '{amount} paid with a company card/operating account is posted directly and is not part of the payroll payment.',
  'trv.pickEmployee': 'Select an employee.',
  'trv.purposeRequired': 'Fill in the purpose of the trip.',
  'trv.travelSaved': 'Trip saved.',
  'trv.calculateSubsistence': 'Calculate subsistence allowance',
  'trv.addStop': '+ Add stop',
  'trv.addPassenger': '+ Add new passenger',
  'trv.addTrailerKm': '+ Driven with trailer',
  'trv.addForestRoadKm': '+ Driven on forest and construction road',
  'trv.pickDateAndStayType': 'Select a date and type of stay.',
  'trv.lodgingDescriptionRequired': 'Enter a description of the place you stayed.',
  'trv.stayTypeHint': 'Choose other accommodation if, for example, you stayed in a rented apartment or bedsit (typically Airbnb or similar).',
  'trv.otherStayHintLead': 'Use only if it was not possible to cook at the place you stayed. If you stayed privately with someone, or if the accommodation had, for example, a hob, you should choose',
  'trv.lodgingHint': 'Required. Enter the name and address of the place you stayed.',
  'trv.mealsHint': 'Mark the meals you paid for yourself. If breakfast was included in the accommodation, do not select breakfast here.',
  'trv.calculatedSubsistence': 'Calculated subsistence allowance ({rate} kr/day · government rate)',
  'trv.expenseRequirements': 'A description, an amount and at least one attachment are required.',
});
